import { render, staticRenderFns } from "./EmailFolders.vue?vue&type=template&id=28f77028&scoped=true&"
import script from "./EmailFolders.vue?vue&type=script&lang=js&"
export * from "./EmailFolders.vue?vue&type=script&lang=js&"
import style0 from "./EmailFolders.vue?vue&type=style&index=0&id=28f77028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f77028",
  null
  
)

export default component.exports